var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('canvas',{ref:"textCanvas",attrs:{"width":_vm.config.width + 'px',"height":_vm.config.height + 'px'}})
}
var staticRenderFns = []

export { render, staticRenderFns }